import { PlanetCardInfoType, PlanetLite } from '@apeiron/planet'
import { DEFAULT_ANIMATE_SHORT_DURATION } from '@apeiron/temp'
import { styled } from '@mui/material'
import Box from '@mui/material/Box'
import PlanetCard from '@src/components/planet/share/planetCard/PlanetCard'
import ListEmptyState from '@src/components/share/list/ListEmptyState'
import ENV_CONFIG from '@src/config'
import { ROUTE } from '@src/constants/route'
import * as R from 'ramda'
import { FC } from 'react'

const PlanetListContainer = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  column-gap: 20px;
  ${props => props.theme.breakpoints.up('res1024')} {
    row-gap: 0px;
  }
  ${props => props.theme.breakpoints.down('res1024')} {
    row-gap: 29px;
  }
`

const StyledPlanetCard = styled(PlanetCard)`
  & {
    transition: transform ${DEFAULT_ANIMATE_SHORT_DURATION}ms ease-out;
  }

  & .PlanetCard-planet {
    transition: filter ${DEFAULT_ANIMATE_SHORT_DURATION}ms linear,
      transform ${DEFAULT_ANIMATE_SHORT_DURATION}ms linear;
  }
  &:hover .PlanetCard-planet {
    filter: brightness(1) saturate(100%);
  }
  &.PlanetCard-disabled .PlanetCard-planet {
    filter: brightness(0.65) contrast(110%) saturate(30%) sepia(30%);
  }
  &.PlanetCard-disabled {
    cursor: default;
  }
  ${props => props.theme.breakpoints.up('res1024')} {
    &:hover:not(.PlanetCard-disabled) {
      transform: translateY(-5px);
    }
  }
  ${props => props.theme.breakpoints.down('res1024')} {
    &:hover:not(.PlanetCard-disabled) {
      transform: translateY(-5px);
    }
    transform-origin: 0 0;
  }
`

const PlanetCardWrapper = Box

export const PlanetList: FC<PlanetListProps> = (props: PlanetListProps) => {
  const {
    cardClassName,
    cardInfoType = PlanetCardInfoType.Conjunction,
    className,
    emptyRecommendation,
    emptyStateDescription,
    enableLink = true,
    planets,
    shouldShowRelic = false,
    renderPlanetUrl,
    onItemClick,
    onPlanetStatusClick,
    onPostProcess
  } = props

  return (
    <>
      {R.isEmpty(planets) ? (
        <ListEmptyState
          description={emptyStateDescription}
          buyURL={emptyRecommendation ? ROUTE.MARKETPLACE_PLANET_LIST : ''}
          rentURL={
            emptyRecommendation ? ENV_CONFIG.EXTERNAL_URL.LOOTRUSH.PLANET : ''
          }
        />
      ) : (
        <PlanetListContainer className={className}>
          {planets.map(planet => {
            return (
              <PlanetCardWrapper key={planet.planetID}>
                <StyledPlanetCard
                  className={cardClassName}
                  infoType={cardInfoType}
                  planet={planet}
                  showRelic={shouldShowRelic}
                  enableLink={enableLink}
                  renderUrl={renderPlanetUrl}
                  onClick={onItemClick}
                  onPostProcess={onPostProcess}
                  onStatusClick={onPlanetStatusClick}
                />
              </PlanetCardWrapper>
            )
          })}
        </PlanetListContainer>
      )}
    </>
  )
}

export type PlanetListProps = {
  cardClassName?: string
  cardInfoType?: PlanetCardInfoType
  className?: string
  emptyStateDescription: string
  emptyRecommendation?: boolean
  enableLink?: boolean
  planets: PlanetLite[]
  shouldShowRelic?: boolean
  renderPlanetUrl?: (planet: PlanetLite) => string
  onItemClick?: (planet: PlanetLite) => void
  onPlanetStatusClick?: (planet: PlanetLite) => void
  onPostProcess?: (planets: PlanetLite) => PlanetLite
}
